<template>
    <!-- 问卷题型统计 -->
    <div class="question-stat"
         @mouseleave.stop="onMouseLeave"
         @mouseenter.stop="onMouseEnter">
        <!-- 题干 -->
        <div class="question-stem">
            <div class="question-stem--text" :class="question.required ? 'is--required': undefined">{{ `Q${number}：${question.stem}` }}</div>
            <transition name="fade-right">
                <el-button type="default"
                           plain
                           icon="el-icon-upload2"
                           v-show="isShowExportBtn"
                           @click.stop="handleExport"
                           size="small">导出
                </el-button>
            </transition>
        </div>
        <!-- 备注 -->
        <div class="question-remark" v-if="question.remark">备注：{{ question.remark }}</div>
        <!-- 渲染单选，多选 -->
        <template v-if="[QUESTION_VAL.single, QUESTION_VAL.multiple].includes(question.type)">
            <el-row type="flex" align="middle" v-for="(item) in question.options" :key="item.Id">
                <el-progress :stroke-width="24"
                             text-inside
                             style="margin: 20px 30px 20px 0; width: 70%;"
                             :format="() => item.type === 'image' ? '图片' : item.text"
                             @click.native.stop="handleProgressClick(item)"
                             :percentage="item.percentage"/>
                <el-tooltip  effect="dark" :content="item.type === 'image' ? '图片' : item.text" placement="top">
                    <div style="flex: 1; text-align: center; margin-left: auto;" class="text-line-1">
                        {{ item.type === "image" ? "图片" : item.text }}
                    </div>
                </el-tooltip>
                <div style="flex: 1; text-align: center; margin-left: auto">{{ item.count }}</div>
                <div style="flex: 1; text-align: center; margin-left: auto">{{ item.percentage + "%" }}</div>
            </el-row>
        </template>
        <template v-else>
            <el-table
                fit
                size="mini"
                highlight-current-row
                tooltip-effect="dark"
                :data="question.answer"
                stripe
                border>
                <el-table-column label="编号" :formatter="(row, column, cellValue, index) => index + 1"/>
                <el-table-column label="答案" prop="Answer"
                                 show-overflow-tooltip
                                 :formatter="(row) => Object.values(row)[0]"/>
                <el-table-column label="操作" prop="action" v-if="isAdmin">
                    <template v-slot="{row}">
                        <el-button type="text"
                                   v-if="Object.keys(row)[0]"
                                   @click.stop="handleViewQuestionnaire(Object.keys(row)[0])">查看答卷
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </template>
        <el-dialog title="查看选项图片"
                   :visible.sync="isShowImageDialog">
            <img :src="dialogImageSrc" alt="dialogImage" width="400px" height="250px"/>
        </el-dialog>
    </div>
</template>

<script>
import { QUESTION_VAL } from "@/utils/question-config";
import { exportReport } from "@/api/new-question-iteration/question-user"
import { downloadUrl } from "download.js";

export default {
    name: "QuestionStat",
    props: {
        // 问卷题
        question: {
            type: Object,
            default() {
                return {}
            },
            required: true
        },
        // 问卷题号
        number: {
            type: [String, Number],
            default: 1
        },
        // 是否是管理员查看
        isAdmin: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            QUESTION_VAL: Object.freeze(QUESTION_VAL),
            isShowExportBtn: false, // 是佛显示导出按钮
            isShowImageDialog: false, // 图片查看对话框
            dialogImageSrc: ""
        }
    },
    methods: {
        handleExport() {
            exportReport(this.question.Id).then(res => {
                downloadUrl(this.question.stem, res)
            })
        },
        // 查看答卷
        handleViewQuestionnaire(userId) {
            const userInfo = this.$store.state.userInfo
            const fn = (name) => {
                this.$router.push({
                    name,
                    query: {
                        Qid: this.question.QuestionnaireId,
                        mode: "view",
                        userId
                    }
                })
            }
            if (Object.isObj(userInfo) && userInfo.isManage) {
                fn("ManageDoQuestionnaire")
            } else {
                fn("DoQuestionnaire")
            }
        },
        // 处理点击进度条
        handleProgressClick(item) {
            if (item.type === "image") {
                this.dialogImageSrc = item.text
                this.isShowImageDialog = true
            }
        },
        // 鼠标移出
        onMouseLeave() {
            if (this.isAdmin) {
                this.isShowExportBtn = false
            }
        },
        // 鼠标移入
        onMouseEnter() {
            if (this.isAdmin) {
                this.isShowExportBtn = true
            }
        }
    }
}
</script>

<style scoped lang="less">
.question-stat {
    border-radius: 12px;
    padding: 34px 60px;
    margin-bottom: 34px;
    background-color: #fff;
    box-sizing: border-box;
}

.question-stem {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 56px;
    line-height: 56px;

    &--text {
        word-break: break-all;
        flex: 1;
        font-size: 16px;
        &.is--required::before {
            content: "*";
            color: #f00;
            vertical-align: middle;
            margin-right: 4px;
            font-size: 20px;
        }
    }
}

.question-remark {
    font-size: 14px;
}

.label {
    position: absolute;
    top: 0;
    bottom: 0;
    text-align: right;
}
</style>
